import types from './types';
import globalTypes from '../globalTypes';
import Cookies from 'react-cookies';

const InitialState = {
    preloaded: false,
    loaded: false,
    notify: {
        text: null,
        key: 0
    },
    language: Cookies.load('language') || "us",
    sounds: (Cookies.load('sounds') || "1") === "1" ? true : false,
    jackpots: null
}

export default (state = InitialState, {type, payload}) => {
    switch(type) {
        case globalTypes.user.logout:
            return {
                ...state,
                notify: InitialState.notify
            }
        case types.jackpots_update:
            return {
                ...state,
                jackpots: state.jackpots ? {
                    ...state.jackpots,
                    [payload.currency]: payload.data
                } : state.jackpots
            }
        case types.jackpots:
            return {
                ...state,
                jackpots: payload
            }
        case types.language:
            return {
                ...state,
                language: payload
            }
        case types.sounds:
            return {
                ...state,
                sounds: !state.sounds
            }
        case types.notify:
            return {
                ...state,
                notify: {
                    text: payload,
                    key: Math.random()
                }
            }
        case types.preloaded:
            return {
                ...state,
                preloaded: true
            }
        case types.loaded:
            return {
                ...state,
                loaded: true
            }
        default:
            return state;
    }
}